export const VALUE_ALT = 'Alt';
export const VALUE_BACK_SPACE = 'Backspace';
export const VALUE_CAPS_LOCK = 'CapsLock';
export const VALUE_CONTROL = 'Control';
export const VALUE_DELETE = 'Delete';
export const VALUE_DOWN = 'ArrowDown';
export const VALUE_ENTER = 'Enter';
export const VALUE_LEFT = 'ArrowLeft';
export const VALUE_META = 'Meta';
export const VALUE_RIGHT = 'ArrowRight';
export const VALUE_SHIFT = 'Shift';
export const VALUE_SPACE = ' ';
export const VALUE_TAB = 'Tab';
export const VALUE_UP = 'ArrowUp';
